export default {
  headerContent: {
    title: 'Mapfre Sigorta Zorunlu Deprem Sigortası (DASK) Fiyatları',
    slogan: "Zorunlu Deprem Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'DASK TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Mapfre Sigorta DASK',
    description: {
      title:
        'Mapfre Sigorta DASK (Zorunlu Deprem Sigortası) Nedir? DASK Ne Demek? ',
      content: [
        'Mapfre Sigorta, deprem sigortası düzenleme yetkisi ile sigortalılarını büyük zararlara karşı koruma altına almaktadır.',
        'Zorunlu deprem sigortası poliçede kapsam altına alınmış teminatlar sonucunda meydana çıkan maddi kayıplara karşı güvence sağlar.'
      ]
    },
    subContent: {
      title: 'Mapfre Sigorta Zorunlu Deprem Sigortası Teminatları Neler?',
      content: [
        {
          paragraph: 'Deprem sigortası teminatları;',
          subList: [
            'Deprem sonrası maddi zarar,',
            'Deprem sonrası yangın,',
            'Deprem sonrası infilak,',
            'Deprem sonrası tsunami,',
            'Deprem sonrası yer kaymasından oluşmaktadır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'DASK Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'DASK Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'DASK Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'DASK Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'DASK Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Mapfre Sigorta DASK Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
